import '@client/translations/i18n';

import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip
} from 'chart.js';
import { polyfill as DnDTouchPolyfill } from 'mobile-drag-drop';

import App from '@client/app/app.svelte';

import { initSentry } from '@client/services/sentry';

import './styles/app.scss';

initSentry();

ChartJS.register(
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip
);

import 'chartjs-adapter-date-fns';

const target = document.getElementById('app');

DnDTouchPolyfill({
  tryFindDraggableTarget(event) {
    const element = event.target.closest('[draggable="true"]');

    if (element) {
      return element;
    }

    return null;
  }
});

const app = new App(
  { target },
  {
    props: {
      ready: false
    }
  }
);

window.initMap = () => app.$set({ ready: true });

export default app;
